import { render, staticRenderFns } from "./EinstellungenAuftrag.vue?vue&type=template&id=480446ce&"
import script from "./EinstellungenAuftrag.vue?vue&type=script&lang=js&"
export * from "./EinstellungenAuftrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports